module.exports = "/education/education-88ac25.html";